import logo from "../assets/images/frcsit-logo.png";
import { useLoader } from "../context/LoaderContext";
import InfoIcon from "@mui/icons-material/Info";

const Loader = () => {
  const { loading } = useLoader();
  return (
    <>
      {loading && (
        <div className="preloader">
          <img
            className="preloader__image"
            width="250"
            height="100"
            src={logo}
            alt="loader-logo"
          />
          <div className="loader-info-container">
            <div className="loader-info-inline">
              <InfoIcon className="loader-info-icon" />
              <span>Please do not refresh or close this tab.</span>
            </div>
            <div className="loader-info-text">
              <span>Your request is being processed.</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Loader;